import { useEffect } from 'react';
import { messages } from 'i18n';
import { TeamInsuranceProduct } from 'types';
import useProductFilter from './useProductFilter';

interface useIsPrimaryFilterProps {
  teamProducts: TeamInsuranceProduct[];
  teamProductsLoaded: boolean;
  paginationReset: () => void;
}

const isPrimaryFilterOptions = [
  messages.addProductsPage.additionalFilters.isPrimary.primary,
  messages.addProductsPage.additionalFilters.isPrimary.excess,
];

export function useIsPrimaryFilter({ teamProducts, teamProductsLoaded, paginationReset }: useIsPrimaryFilterProps) {
  const preSelectedFilter = messages.addProductsPage.additionalFilters.isPrimary.primary;
  const baseFiltersList = isPrimaryFilterOptions.map((label) => ({
    key: label,
    checked: label === preSelectedFilter,
    label,
  }));

  const isPrimaryFilter = useProductFilter({
    baseFiltersList,
    defaultSelectAll: false,
    paginationReset,
  });

  const setIsPrimaryFilters = isPrimaryFilter.setFilters;

  useEffect(() => {
    if (!teamProductsLoaded || teamProducts.length === 0) {
      return;
    }

    const isPrimaryFilterSetter = (isPrimaryList: string[]) => {
      setIsPrimaryFilters((prev) =>
        isPrimaryList.map((label) => ({
          key: label,
          checked: prev.find((item) => item.key === label)?.checked ?? false,
          label,
        })),
      );
    };

    isPrimaryFilterSetter(isPrimaryFilterOptions);
  }, [teamProductsLoaded, teamProducts, setIsPrimaryFilters]);

  return isPrimaryFilter;
}
